import { toCurrency } from '@/utils';
import { toFormattedDate } from '@/utils/date';

export const SALARY_SETTLEMENT_FILTER_KEYS = {
  STARTS_ON: 'starts_on',
  ENDS_ON: 'ends_on',
  SALARY_OR_HOURLY: 'salary_or_hourly',
  PAY_SCHEDULE: 'pay_schedule_id',
  DIVISION: 'division_id',
  BANKING_PROVIDER: 'banking_provider',
  PAYMENT_RAIL: 'payment_rail',
};

export const SALARY_SETTLEMENT_API_FILTER_KEYS = [
  SALARY_SETTLEMENT_FILTER_KEYS.STARTS_ON,
  SALARY_SETTLEMENT_FILTER_KEYS.ENDS_ON,
];

export const SALARY_SETTLEMENT_SEARCH_FIELDS = ['employee_code', 'full_name', 'work_email'];

export const SALARY_SETTLEMENT_FIELD_KEYS = {
  EMPLOYEE_CODE: 'employee_code',
  FULL_NAME: 'full_name',
  WORK_EMAIL: 'work_email',
  SALARY_COMPLETED_AT: 'salary_completed_at',
  SALARY_QUEUED_AT: 'salary_queued_at',
  BANKING_PROVIDER: 'banking_provider',
  PAYMENT_RAIL: 'payment_rail',
  AMOUNT_SETTLED: 'amount_settled',
  TOTAL_TRANSFERRED: 'total_transferred',
  SALARY_AMOUNT: 'salary_amount',
  SETTLEMENT_AMOUNT: 'settlement_amount',
  ENROLLED_DATE: 'enrolled_date',
  DISABLED_DATE: 'disabled_date',
  WAS_ENROLLED_THIS_PERIOD: 'was_enrolled_this_period',
  WAS_DISABLED_THIS_PERIOD: 'was_disabled_this_period',
};

export const SALARY_SETTLEMENT_FIELD_DEFINITIONS = [
  {
    key: SALARY_SETTLEMENT_FIELD_KEYS.FULL_NAME,
    label: 'Employee Name',
    sortable: true,
  },
  {
    key: SALARY_SETTLEMENT_FIELD_KEYS.WORK_EMAIL,
    label: 'Email',
    sortable: true,
  },
  {
    key: SALARY_SETTLEMENT_FIELD_KEYS.SALARY_COMPLETED_AT,
    label: 'Salary Completed',
    sortable: true,
    formatter: value => (value ? toFormattedDate(value, 'DD/MM/YYYY HH:mm') : '-'),
  },
  {
    key: SALARY_SETTLEMENT_FIELD_KEYS.SALARY_AMOUNT,
    label: 'Salary Amount',
    sortable: true,
    formatter: value => toCurrency(value || 0),
    tdClass: 'text-right',
    thClass: 'text-right',
  },
  {
    key: SALARY_SETTLEMENT_FIELD_KEYS.AMOUNT_SETTLED,
    label: 'Amount Settled',
    sortable: true,
    formatter: value => toCurrency(value || 0),
    tdClass: 'text-right',
    thClass: 'text-right',
  },
  {
    key: SALARY_SETTLEMENT_FIELD_KEYS.TOTAL_TRANSFERRED,
    label: 'Total Transferred',
    sortable: true,
    formatter: value => toCurrency(value || 0),
    tdClass: 'text-right',
    thClass: 'text-right',
  },
  {
    key: SALARY_SETTLEMENT_FIELD_KEYS.ENROLLED_DATE,
    label: 'Enrolled Date',
    sortable: true,
    formatter: value => (value ? toFormattedDate(value, 'DD/MM/YYYY HH:mm') : '-'),
  },
  {
    key: SALARY_SETTLEMENT_FIELD_KEYS.DISABLED_DATE,
    label: 'Disabled Date',
    sortable: true,
    formatter: value => (value ? toFormattedDate(value, 'DD/MM/YYYY HH:mm') : '-'),
  },
];

export const SALARY_SETTLEMENT_PER_PAGE_OPTIONS = [25, 50, 100, 250];
